import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the DecimalPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'toFixed',
})
export class ToFixedPipe implements PipeTransform {

  /**
   * 整数データの場合は、小数点を付与して表示させる
   *  ex) 36 -> 36.0
   *  ex) 36.1 -> 1
   *  ex) 0 -> 0
   *  
   * @param value
   */
  transform(value: number) {
    if (value === 0) {
      return 0;
    }
    // それいがいは、小数点を付与する
    return (value).toFixed(1);
  }
}



// WEBPACK FOOTER //
// ./src/pipes/number-format/to-fixed.ts